import React from "react";
import { FieldPath, FieldValues, Path } from "react-hook-form";
import { SelectGroup, SelectOption } from "../../control";
import { OptionsOrGroups } from "../../select";
import { useSelectOptions } from "../hooks";
import { pathToArray } from "../utils";

interface SelectWrapperProps<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  parentControlNames?: FieldPath<TFieldValues> | FieldPath<TFieldValues>[];
  options: OptionsOrGroups<
    SelectOption<string>,
    SelectGroup<SelectOption<string>>
  >;
  children: React.ReactElement;
}

export function SelectWrapper<TFieldValues extends FieldValues>(
  props: Readonly<SelectWrapperProps<TFieldValues>>,
) {
  const { name, parentControlNames, options, children } = props;

  const parsedOptions = useSelectOptions(
    name,
    pathToArray(parentControlNames) ?? [],
    options,
  );

  return React.cloneElement(children, {
    options: parsedOptions,
  });
}
